export function parseBool(val?: string): boolean | undefined {
  if (val === undefined || val === null) {
    return undefined;
  }

  return val.toLowerCase() === 'true';
}
